document.addEventListener('DOMContentLoaded', function () {
    const contactFormOptions = {
        components: {},

        init: function () {
            this.loadComponents();
            this.checkComponents();
            this.setEvents();
        },

        loadComponents: function () {
            this.components = {
                'main': document.getElementById('main_reason'),
                'reference': document.getElementById('order_reference'),
                'target1': document.getElementById('target_1'),
                'target2': document.getElementById('target_2'),
                'target3': document.getElementById('target_3'),
                'target4': document.getElementById('target_4'),
            };
        },

        checkComponents: function () {
            for (const [key, value] of Object.entries(this.components)) {
                if (!value) {
                    throw new Error(`Contact form options: ${key} is undefined.`);
                }
            }
        },

        setEvents: function () {
            const _this = this;
            this.components.main.addEventListener('change', function () {
                _this.hideAllTargets();
                _this.showTarget(this.options[this.selectedIndex].getAttribute('data-target'));
            });
        },

        hideAllTargets: function () {
            for (const [key, value] of Object.entries(this.components)) {
                if (key !== 'main') {
                    value.style.display = 'none';
                    value.querySelectorAll('select').forEach(select => {
                        select.disabled = true;
                        select.required = false;
                    });
                    value.querySelectorAll('input').forEach(input => {
                        input.disabled = true;
                        input.required = false;
                    });
                }
            }
        },

        showTarget: function (index) {
            const key = 'target' + index;
            if (this.components.hasOwnProperty(key)) {
                this.components[key].style.display = 'block';
                this.components[key].querySelectorAll('select').forEach(select => {
                    select.disabled = false;
                    select.required = true;
                });

                if (key === 'target2') {
                    this.components['reference'].style.display = 'block';
                    this.components['reference'].querySelectorAll('input').forEach(input => {
                        input.disabled = false;
                        input.required = true;
                    });
                }
            }
        }
    };

    contactFormOptions.init();
});